import validate from "/tmp/build_58fff9e7/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/tmp/build_58fff9e7/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  redirect: () => import("/tmp/build_58fff9e7/middleware/redirect.ts")
}